var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoExpandedWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 257.725,
    height: 43.208,
    viewBox: "0 0 257.725 43.208",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_3876",
    "data-name": "Rect\\xE1ngulo 3876",
    width: 257.725,
    height: 43.208,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5284",
    "data-name": "Grupo 5284",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4275",
    "data-name": "Trazado 4275",
    d: "M131.544,43.256H131.3a9.386,9.386,0,0,1-1.522,1.876,7.112,7.112,0,0,1-4.861,1.828c-4.47,0-7.613-3.21-7.613-6.914,0-4.2,2.652-6.913,7.367-7.9l6.875-1.481a3.32,3.32,0,0,0-3.438-2.469,6.125,6.125,0,0,0-3.633,1.234l-.015.01a2.178,2.178,0,0,1-2.762-.2l-2.511-2.384a.571.571,0,0,1-.029-.8,13.659,13.659,0,0,1,2.271-1.905,12.979,12.979,0,0,1,7.415-2.37c6.679,0,11.05,4.394,11.05,9.679V45.9a.566.566,0,0,1-.564.567h-4.592a3.2,3.2,0,0,1-3.194-3.211Zm0-7.653-3.438.741a2.6,2.6,0,0,0-2.209,2.221c0,1.334.737,1.975,2.209,1.975,1.965,0,3.438-1.432,3.438-4.2Z",
    transform: "translate(-59.1 -10.912)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4276",
    "data-name": "Trazado 4276",
    d: "M189.656,33.089h-.246a8.909,8.909,0,0,1-1.621,1.975,8.208,8.208,0,0,1-5.5,1.975c-5.647,0-10.558-4.938-10.558-12.592s4.911-12.592,10.558-12.592a8.213,8.213,0,0,1,5.5,1.974A8.932,8.932,0,0,1,189.41,15.8h.246V4.073a2.089,2.089,0,0,1,2.082-2.094h6.035a.231.231,0,0,1,.231.232v34.1a.231.231,0,0,1-.231.231h-4.679a3.447,3.447,0,0,1-3.438-3.453Zm0-8.641a4.673,4.673,0,1,0-4.665,4.937,4.9,4.9,0,0,0,4.665-4.937",
    transform: "translate(-86.523 -0.992)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4277",
    "data-name": "Trazado 4277",
    d: "M252.479,33.1h-.246a8.9,8.9,0,0,1-1.623,1.974,8.208,8.208,0,0,1-5.5,1.97c-5.647,0-10.553-4.948-10.546-12.6s4.922-12.587,10.569-12.582a8.212,8.212,0,0,1,5.5,1.98,8.869,8.869,0,0,1,1.619,1.977h.246l.011-11.732a2.089,2.089,0,0,1,2.085-2.092L260.436,2a.421.421,0,0,1,.418.422l-.031,33.723a.42.42,0,0,1-.42.421h-4.491a3.447,3.447,0,0,1-3.433-3.466Zm.012-8.646a4.673,4.673,0,1,0-4.665,4.937,4.9,4.9,0,0,0,4.665-4.937",
    transform: "translate(-118.179 -0.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4278",
    "data-name": "Trazado 4278",
    d: "M320.3,43.177a.443.443,0,0,1-.094.567,12.809,12.809,0,0,1-2.317,1.487,14.952,14.952,0,0,1-7.219,1.728c-7.612,0-13.259-5.679-13.259-12.592a12.663,12.663,0,0,1,12.768-12.592A12.248,12.248,0,0,1,322.7,34.121a12.987,12.987,0,0,1-.1,1.441.569.569,0,0,1-.538.508l-15.861.767a.161.161,0,0,0-.16.194c.376,1.454,2.306,3.262,5.361,3.262a9.24,9.24,0,0,0,4.322-1.086l.017-.01a1.918,1.918,0,0,1,2.617.683Zm-6.171-11.525a.162.162,0,0,0,.152-.214,4.306,4.306,0,0,0-8.2,0,.162.162,0,0,0,.152.214Z",
    transform: "translate(-149.844 -10.912)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4279",
    "data-name": "Trazado 4279",
    d: "M359.173,22.27H365.2a.432.432,0,0,1,.431.434v3.022h.246a6.983,6.983,0,0,1,6.384-3.95,6.867,6.867,0,0,1,4.96,2.123,6.759,6.759,0,0,1,1.424,2.074h.246A7.648,7.648,0,0,1,380.8,23.9a9.69,9.69,0,0,1,6.188-2.123c4.469,0,8.1,3.8,8.1,10.37V46.032a.432.432,0,0,1-.431.434h-6.023a1.9,1.9,0,0,1-1.894-1.9V33.38c0-2.519-1.227-3.7-2.947-3.7-1.964,0-3.437,1.432-3.437,4.2V46.032a.433.433,0,0,1-.432.434H373.9a1.9,1.9,0,0,1-1.893-1.9V33.38c0-2.519-1.228-3.7-2.947-3.7-1.964,0-3.437,1.432-3.437,4.2V46.032a.432.432,0,0,1-.431.434h-6.024a1.9,1.9,0,0,1-1.894-1.9V24.174a1.9,1.9,0,0,1,1.894-1.9",
    transform: "translate(-180.008 -10.912)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4280",
    "data-name": "Trazado 4280",
    d: "M449.03,0a4.415,4.415,0,0,1,4.67,4.445,4.671,4.671,0,0,1-9.331,0A4.415,4.415,0,0,1,449.03,0m-3.807,11.358h7.614a.368.368,0,0,1,.367.369V35.185a.368.368,0,0,1-.367.369H446.75a1.9,1.9,0,0,1-1.894-1.9V11.728a.368.368,0,0,1,.367-.369",
    transform: "translate(-223.884)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4281",
    "data-name": "Trazado 4281",
    d: "M495.5,41.871a.246.246,0,0,1,.018.316,12.154,12.154,0,0,1-2.381,2.3,13.09,13.09,0,0,1-7.808,2.469c-7.612,0-13.259-5.679-13.259-12.592s5.647-12.592,13.259-12.592a13.09,13.09,0,0,1,7.808,2.468,12.154,12.154,0,0,1,2.381,2.3.246.246,0,0,1-.018.316l-3.459,3.652a1.905,1.905,0,0,1-2.523.2l-.064-.046a6.24,6.24,0,0,0-3.634-1.235,4.943,4.943,0,1,0,0,9.876,5.922,5.922,0,0,0,3.634-1.234,6.021,6.021,0,0,0,1.112-1.031.23.23,0,0,1,.346-.012Z",
    transform: "translate(-237.844 -10.912)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4282",
    "data-name": "Trazado 4282",
    d: "M15.68,7.479h0a3.633,3.633,0,1,1,3.613-3.633A3.633,3.633,0,0,1,15.68,7.479",
    transform: "translate(-6.08 -0.107)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4283",
    "data-name": "Trazado 4283",
    d: "M63.66,79.306h0a3.633,3.633,0,1,1,3.613-3.633,3.633,3.633,0,0,1-3.613,3.633",
    transform: "translate(-30.253 -36.098)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4284",
    "data-name": "Trazado 4284",
    d: "M41.926,7.478h-8.29a3.633,3.633,0,0,1,0-7.266h8.291a3.633,3.633,0,0,1,0,7.266",
    transform: "translate(-15.126 -0.106)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4285",
    "data-name": "Trazado 4285",
    d: "M57.58,25.435H51.593a3.633,3.633,0,0,1,0-7.266H57.58a3.633,3.633,0,0,1,0,7.266",
    transform: "translate(-24.174 -9.104)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4286",
    "data-name": "Trazado 4286",
    d: "M24.658,43.392H44.009a3.633,3.633,0,0,0,0-7.266H24.658a3.633,3.633,0,0,0,0,7.266",
    transform: "translate(-10.603 -18.102)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4287",
    "data-name": "Trazado 4287",
    d: "M43.164,61.349h10.17a3.633,3.633,0,0,0,0-7.266H43.164a3.633,3.633,0,1,0,0,7.266",
    transform: "translate(-19.927 -27.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4288",
    "data-name": "Trazado 4288",
    d: "M3.613,61.349H9.6a3.633,3.633,0,0,0,0-7.266H3.613a3.633,3.633,0,1,0,0,7.266",
    transform: "translate(0 -27.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4289",
    "data-name": "Trazado 4289",
    d: "M27.7,79.306h5.892a3.633,3.633,0,0,0,0-7.266H27.7a3.633,3.633,0,1,0,0,7.266",
    transform: "translate(-12.136 -36.098)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoExpandedWhite);
export default __webpack_public_path__ + "static/media/logo_expanded_white.958a7fd4.svg";
export { ForwardRef as ReactComponent };